interface EqualizerBarsProps {
  active: boolean;
  size?: 'sm' | 'lg';
}

export function EqualizerBars({ active, size = 'sm' }: EqualizerBarsProps) {
  const height = size === 'lg' ? 'h-8' : 'h-5';
  return (
    <span
      className={
        active
          ? `is-playing flex ${height} items-end gap-0.5`
          : `flex ${height} items-end gap-0.5`
      }
      aria-hidden
    >
      <span className="eq-bar" />
      <span className="eq-bar" />
      <span className="eq-bar" />
      <span className="eq-bar" />
      <span className="eq-bar" />
    </span>
  );
}
